import { render, staticRenderFns } from "./add.vue?vue&type=template&id=e62fa0ba&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e62fa0ba')) {
      api.createRecord('e62fa0ba', component.options)
    } else {
      api.reload('e62fa0ba', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=e62fa0ba&", function () {
      api.rerender('e62fa0ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/lostAndFound/queryList/add.vue"
export default component.exports